import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Form, reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Field } from 'redux-form'
import { Button, Icon } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { CancelPRContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { cancelPr } from 'ducks/support'

const CancelPR = (props) => {
  const { members, memberLoading, reset } = props

  useEffect(() => {
    if (!members.length) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }
  }, [])

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  return (
    <CancelPRContainer>
      <Form>
        <div className='rowFields'>
          <Field 
            name='docNumber' 
            label='PR Document Number' 
            type={type.text}
            component={FieldInput} />
          <Field 
            name='requester' 
            label='Requester (User request cancel document)' 
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
        </div>
        <div className='rowFields'>
          <Field 
            name='reason' 
            label='Reason' 
            type={type.textArea}
            component={FieldInput} />
        </div>
        <div className='btnContainer'>
          <Button
            type='button'
            content='Submit'
            color='blue'
            icon='paper plane outline'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => props.cancelPr(props.valueForm, reset)}
          />
        </div>
      </Form>
    </CancelPRContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    valueForm: getFormValues('cancelPrForm')(state) || {},
  })
}

const mapDispatchToProps = {
  getHrmsMembers,
  cancelPr,
  getAllMembers
}

const validate = (values) => {
  let errors = {}
  validations(values, 'docNumber', [vCase.require], errors)
  validations(values, 'requester', [vCase.require], errors)
  validations(values, 'reason', [vCase.require], errors)

  return errors
}

const CancelPRForm = reduxForm({
  form: 'cancelPrForm',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CancelPR)

export default connect(mapStateToProps, mapDispatchToProps)(CancelPRForm)